import { EventBus, EventType } from 'scbk-services/event-bus/bus/event-bus';

/**
 * 로딩바 매니저
 */
class LoadingManager {
    private count: number = 0;
    private visible: boolean = false;
    private showTimer?: number;
    private hideTimer?: number;

    private readonly showDelay: number = 150;
    private readonly minVisibleTime: number = 500;

    private showAt: number = 0;

    open() {
        this.count++;

        if (import.meta.env.VITE_ENVIRONMENT === 'dev') {
            console.trace('😊loadingManager open');
        }

        if (this.visible || this.showTimer) {
            return;
        }

        this.showTimer = window.setTimeout(() => {
            this.showTimer = undefined;

            if (this.count > 0) {
                this.visible = true;
                this.showAt = Date.now();
                this.emit();
            }
        }, this.showDelay);
    }

    close() {
        this.count = Math.max(0, this.count - 1);

        if (this.count > 0) {
            return;
        }

        if (!this.visible) {
            return;
        }

        const elapsedTime = Date.now() - this.showAt;
        const remainTime = Math.max(0, this.minVisibleTime - elapsedTime);

        console.log('# LoadingManager remainTime=', remainTime);

        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }

        this.hideTimer = window.setTimeout(() => {
            this.hideTimer = undefined;

            if (this.count === 0) {
                this.visible = false;
                this.emit();
            }
        }, remainTime);
    }

    emit() {
        EventBus.getInstance().emit(
            this.visible ? EventType.ShowLoadingBar : EventType.HideLoadingBar,
        );
    }

    reset() {
        this.count = 0;

        if (this.showTimer) {
            clearTimeout(this.showTimer);
        }

        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }

        this.showTimer = undefined;
        this.hideTimer = undefined;

        if (this.visible) {
            this.visible = false;
            this.emit();
        }
    }
}

export const loadingManager = new LoadingManager();
